"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.SliderPopinEntity = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../types");
var field_groups_1 = require("../../field-groups");
var fields_1 = require("../../fields");
var popin_factory_1 = require("./popin-factory");
var prismicSlideToWebSlide = function (prismicSlide, logger) {
    var _a, _b, _c, _d, _e;
    var imageWithCredits = field_groups_1.toImageWithCredits(prismicSlide === null || prismicSlide === void 0 ? void 0 : prismicSlide.primary, logger);
    if (imageWithCredits) {
        return utils_1.compact({
            title: fields_1.toText((_a = prismicSlide === null || prismicSlide === void 0 ? void 0 : prismicSlide.primary) === null || _a === void 0 ? void 0 : _a.title),
            quote: fields_1.toText((_b = prismicSlide === null || prismicSlide === void 0 ? void 0 : prismicSlide.primary) === null || _b === void 0 ? void 0 : _b.quote),
            subtitle: fields_1.toText((_c = prismicSlide === null || prismicSlide === void 0 ? void 0 : prismicSlide.primary) === null || _c === void 0 ? void 0 : _c.subtitle),
            text: fields_1.toRichText((_d = prismicSlide === null || prismicSlide === void 0 ? void 0 : prismicSlide.primary) === null || _d === void 0 ? void 0 : _d.text, logger),
            imageWithCredits: imageWithCredits,
            imagePosition: logger.required(logger.toConstValue((_e = prismicSlide === null || prismicSlide === void 0 ? void 0 : prismicSlide.primary) === null || _e === void 0 ? void 0 : _e.imagePosition, {
                Gauche: 'left',
                Droite: 'right'
            }))
        });
    }
    return undefined;
};
exports.SliderPopinEntity = popin_factory_1.popinFactory(types_1.DocumentType.SLIDER_POPIN, function (prismicDoc, normalizedPopin, logger) {
    var _a, _b;
    return utils_1.compact(__assign(__assign({}, normalizedPopin), { slides: (_b = (_a = prismicDoc.data) === null || _a === void 0 ? void 0 : _a.slides_slices) === null || _b === void 0 ? void 0 : _b.map(function (slide) { return prismicSlideToWebSlide(slide, logger); }).filter(Boolean) }));
});
//# sourceMappingURL=slider-popin.js.map